var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comment-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.69,
    height: 103.414,
    viewBox: "0 0 123.69 103.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M61.845,51.707A15.512,15.512,0,1,1,77.306,36.2,15.506,15.506,0,0,1,61.845,51.707Zm0-25.854A10.342,10.342,0,1,0,72.152,36.2,10.335,10.335,0,0,0,61.845,25.854ZM87.614,80.146c0-12.394-12.044-23.268-25.769-23.268S36.076,67.752,36.076,80.146a2.577,2.577,0,1,0,5.154,0c0-8.542,8.813-18.1,20.615-18.1S82.46,71.6,82.46,80.146a2.577,2.577,0,1,0,5.154,0ZM68.146,103.414H18.038A18.088,18.088,0,0,1,0,85.317V18.1A18.088,18.088,0,0,1,18.038,0h87.614A18.088,18.088,0,0,1,123.69,18.1V85.317a18.088,18.088,0,0,1-18.038,18.1H68.146ZM18.038,5.171A12.921,12.921,0,0,0,5.154,18.1V85.317A12.92,12.92,0,0,0,18.038,98.244H79.973s5.951,0,6.548,0h19.131a12.917,12.917,0,0,0,12.884-12.927V18.1A12.917,12.917,0,0,0,105.652,5.171Z",
    fill: "#8e8e8e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericUserIcon);
export default __webpack_public_path__ + "static/media/genericUserIcon.bf28843ee341b552b8afccfe40d37b3a.svg";
export { ForwardRef as ReactComponent };